import React from "react";
import tw, { css, styled } from "twin.macro";

import CalculateRoiButton from "../buttons/CalculateRoiButton";
import GetADemoButton from "../buttons/GetADemoButton";
import Container from "../common/Container";
import Section, {
  SectionColor,
  SectionContent,
  SectionCta,
  SectionHeader,
  SectionHeadline,
  SectionHeadlineHighlight,
  SectionSubheadline,
} from "../common/Section";
import CustomBrandingSlider from "./CustomBrandingSlider";

const CustomBrandingFlow: React.FunctionComponent = (props) => (
  <Container {...props}>
    <Section color={SectionColor.Gray}>
      <SectionHeader>
        <SectionHeadline>
          The perfect cancellation flow for{" "}
          <SectionHeadlineHighlight>your brand</SectionHeadlineHighlight>
        </SectionHeadline>

        <SectionSubheadline tw="max-w-prose mx-auto">
          Details matter. Own your cancellation experience with seamless
          branding and instant edits. It’s a beautiful thing.
        </SectionSubheadline>
      </SectionHeader>
      <SectionContent>
        <CustomBrandingSlider />
      </SectionContent>
      <SectionCta
        buttons={
          <>
            <GetADemoButton />
            <CalculateRoiButton />
          </>
        }
      />
    </Section>
  </Container>
);

export default CustomBrandingFlow;
